function AboutUs() {
  return (
    <div className="leftContainer page_layout">
      <div className="Orher_page_main_section">
        <h1 className="profile_headings">About Us</h1>
        <div>
          King Mastar WEBTECH PRIVATE LIMITED King Mastar , is a real-time online
          LUDO card game which fully owned by King Mastar WEBTECH PRIVATE
          LIMITED. We are a passionate team of designers and developers with
          years experience in the card game industry. Our aim is to provide you
          an awesome online experience on this sophisticated handmade product!
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
